export default __webpack_public_path__ + "img/70cd992373c1eb29b4dc7ff71d68cef5.png";